import React from "react";
import { formatDate } from "../../../../../../components/common/Converter";
export default function PrintTrainingCertificate({ object }) {
  // console.log("OBJ: ", object);
  const dataPosition = (data, style) => {
    return (
      <div
        style={{
          //   border: "1px solid",
          position: "absolute",
          textAlign: "center",
          display: "flex",
          alignItems: "flex-end", // Align to bottom
          justifyContent: "center",
          overflow: "hidden",
          lineHeight: "1",
          padding: "0 1rem",
          ...style,
        }}
      >
        <p
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxHeight: "2.4em", // Approximately 2 lines
            margin: 0,
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: data }} />
          {/* {data} */}
        </p>
      </div>
    );
  };

  const footerData = (label, value) => {
    return (
      <div
        style={{
          width: "50%",
          //   border: "1px solid",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "4rem",
        }}
      >
        {/* <label style={{ color: "#c71d28", fontSize: "40px" }}>{number}</label> */}
        <label>
          <span style={{ color: "#d1913d" }}>{label}</span>
          <br />
          <span style={{ fontStyle: "italic", fontWeight: "bold" }}>
            {value}
          </span>
        </label>
      </div>
    );
  };

  const fullName = `${object?.Firstname || ""} ${object?.Middlename || ""} ${
    object?.surname || ""
  }`.trim();
  const training = `${object?.training || ""}`;
  const dateToday = formatDate(new Date());
  const firstSignatory = object?.firstSignatory || "";
  const firstpos = object?.firstpos || "";
  const secondSignatory = object?.secondSignatory || "";
  const secondpos = object?.secondpos || "";
  const thirdSignatory = object?.thirdSignatory || "";
  const thirdpos = object?.thirdpos || "";
  const fourthSignatory = object?.fourthSignatory || "";
  const fourthpos = object?.fourthpos || "";

  return (
    <div
      style={{
        width: "11.69in",
        display: "flex",
        justifyContent: "center",
        marginLeft: "-10px",
        marginTop: "-10px",
        alignItems: "center",
        position: "relative",
        fontSize: "11px",
      }}
    >
      <img
        src="/trainingCert.png"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain", // Keeps aspect ratio, no stretching
        }}
        alt="certificate"
      />
      {/* data  */}
      {dataPosition(`${fullName}`, {
        color: "#03045e",
        fontFamily: "Vivaldi, Verdana", // Fallback if Vivaldi not available
        fontStyle: "italic",
        height: "5rem",
        fontSize: "40px",
        width: "53rem",
        top: "23rem",
        left: "15rem",
        fontWeight: "bold",
      })}
      {dataPosition(`For Completing: <b>${training}</b>`, {
        height: "auto",
        fontSize: "20px",
        width: "53rem",
        top: "28.5rem",
        left: "15rem",
      })}
      {dataPosition(`Given this Day of: <b>${dateToday}</b>`, {
        height: "auto",
        fontSize: "20px",
        width: "53rem",
        top: "30rem",
        left: "15rem",
      })}
      <div
        style={{
          //   border: "1px solid",
          position: "absolute",
          fontSize: "20px",
          width: "53rem",
          top: "35.3rem",
          left: "15rem",
          height: "10rem",
        }}
      >
        <div
          style={{
            height: "50%",
            // border: "1px solid",
            display: "flex",
            textAlign: "center",
          }}
        >
          {(thirdSignatory || thirdSignatory) &&
            footerData(`${thirdSignatory}`, `${thirdpos}`)}
          {(fourthSignatory || fourthpos) &&
            footerData(`${fourthSignatory}`, `${fourthpos}`)}
        </div>
        <div
          style={{
            height: "50%",
            // border: "1px solid",
            display: "flex",
            textAlign: "center",
          }}
        >
          {(secondSignatory || secondpos) &&
            footerData(`${secondSignatory}`, `${secondpos}`)}
          {(firstSignatory || firstpos) &&
            footerData(`${firstSignatory}`, `${firstpos}`)}
        </div>
      </div>
    </div>
  );
}
